import { SELECTOR, setSelector } from '@socialive/common';
import { selectCurrentUserId } from '~/store/accountInfo';

setSelector(SELECTOR.USER_ID, selectCurrentUserId);

export default selectCurrentUserId;
